import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { guaranteeItems } from '../../data/content';
export function Guarantee() {
  return <section className="w-full bg-teal-mist px-4 py-14 sm:px-6 sm:py-20" aria-labelledby="guarantee-title" data-id="element-211" data-mp="24moo70h2fqj9">
      <div className="mx-auto max-w-3xl" data-id="element-212" data-mp="29e6nzl7crl2n">
        <div className="rounded-3xl border-2 border-teal/30 bg-white p-6 sm:p-9" data-id="element-213" data-mp="29f81dwbucjnj">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-teal text-white" aria-hidden="true" data-id="element-214" data-mp="2echyly5h1zlx">
            <ShieldCheckIcon className="h-7 w-7" data-id="element-215" data-mp="2oanyybbmqxoo" />
          </span>

          <p className="mt-5 text-[12px] font-extrabold uppercase tracking-[0.14em] text-teal-dark" data-id="element-216" data-mp="2o937iukm3uv1">
            7-day guarantee
          </p>
          <h2 id="guarantee-title" className="mt-2 font-display text-[26px] font-bold leading-tight text-navy sm:text-[34px]" data-id="element-217" data-mp="txy51tl9hoha">
            Explore 5-MIN MENOPAUSE™ completely risk-free.
          </h2>

          <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-218" data-mp="3smrdlgrvqkq1">
            {guaranteeItems.map(item => <li key={item} className="flex items-center gap-2.5 rounded-xl bg-teal-mist px-4 py-3 text-[14px] font-semibold text-navy" data-id="element-219" data-mp="3nteybx93bq9y">
                <CheckIcon className="h-4 w-4 shrink-0 text-teal-dark" strokeWidth={3} aria-hidden="true" data-id="element-220" data-mp="3dy3mbmp2gx5w" />
                {item}
              </li>)}
          </ul>

          <p className="mt-6 text-[14.5px] leading-relaxed text-navy/70 sm:text-[15.5px]" data-id="element-221" data-mp="agv7zctjsffx">
            If within 7 days you decide that 5-MIN MENOPAUSE™ doesn’t provide meaningful value to
            the way you organize your menopause consultations, contact us to request a refund
            according to the guarantee terms.
          </p>

          <div className="mt-8" data-id="element-222" data-mp="2q4les2nkgg5c">
            <CtaButton label="Try it risk-free for 7 days" subtext="One-time $27 · Instant access · Refund within 7 days per guarantee terms" data-id="element-223" data-mp="2l7d5ysob5ogr" />
          </div>
        </div>
      </div>
    </section>;
}